import toastStore from '@src/application/store/toast-store';
import Toast from '@src/application/toast';
import { markRaw } from 'vue';
import Text from '@components/text.vue';
import { v4 } from 'uuid';

export function addToast(message, context = 'isSuccess', time = 1500) {
    toastStore.toasts.data.push(new Toast(v4(), markRaw(Text), { content: message, gap: '0' }, context, time));
}

export function addComponentToast(component, props, context = 'isSuccess', time = 1500) {
    toastStore.toasts.data.push(new Toast(v4(), markRaw(component), props, context, time));
}

export function removeToast(uuid) {
    for (let i = 0; i < toastStore.toasts.data.length; i++) {
        if (toastStore.toasts.data[i].uuid !== uuid) {
            continue;
        }

        toastStore.toasts.data.splice(i, 1);
        return;
    }
}
